import { useState, useContext, useEffect } from "react";
import "./dashboardNavbar.scss";
import { useNavigate } from "react-router-dom";
import { Dropdown, Space } from "antd";
import type { MenuProps } from "antd";
import { useLocation } from "react-router-dom";

// context
import { AuthContext } from "../../../contexts/authContext";
import { AppContext } from "../../../contexts/appCotext";

// icon
import {
  userIcon,
  piechartIcon,
  questionMarkIcon,
  hamburgerMenuIcon,
  listIcon,
  editIcon,
  logoutIcon,
} from "../../../constants/icons";

// image
import { images } from "../../../constants/images";

// ui-component
import LogoContainer from "../../UI/LogoContainer/LogoContainer";

const DashboardNavbar = () => {
  const { user, logoutUser } = useContext(AuthContext);
  const { toggleNavDrawer } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState<string>("evaluation");
  const handleLogout = async () => {
    try {
      const res = await logoutUser();
      if (res.status === 200 && res.success === true) {
        return navigate("/");
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  const items: MenuProps["items"] = [
    {
      label: (
        <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {editIcon} Edit
        </span>
      ),
      key: "0",
    },
    {
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            color: "red",
          }}
          onClick={handleLogout}
        >
          {logoutIcon} Logout
        </span>
      ),
      key: "1",
    },
  ];

  useEffect(() => {
    let pathSplit = location.pathname.split("/");
    setActiveTab(pathSplit[2]);
  }, [location]);

  return (
    <div className="dashboardNavbar">
      <img className="topbar" src={images.topbar} alt="Topbar" />
      <div className="container">
        <LogoContainer />
        <div className="tabs">
          {user.role === "admin" && (
            <>
              <div className="tab" onClick={() => navigate("/dashboard/users")}>
                <span>{userIcon} Users</span>
                <hr
                  className={`tabIndicator ${
                    activeTab === "users" && "active"
                  }`}
                />
              </div>
              <div
                className="tab"
                onClick={() => navigate("/dashboard/catalog")}
              >
                <span>{listIcon} Catalog</span>
                <hr
                  className={`tabIndicator ${
                    activeTab === "catalog" && "active"
                  }`}
                />
              </div>
            </>
          )}

          <div
            className="tab"
            onClick={() => navigate("/dashboard/evaluation")}
          >
            <span>{piechartIcon} Your evaluations</span>
            <hr
              className={`tabIndicator ${
                activeTab === "evaluation" && "active"
              }`}
            />
          </div>
          <div className="tab" onClick={() => navigate("/dashboard/about")}>
            <span>{questionMarkIcon} What is HAIQU?</span>
            <hr
              className={`tabIndicator ${activeTab === "about" && "active"}`}
            />
          </div>
        </div>
        <div className="actionButtonHolder">
          <div className="hamMenu" onClick={toggleNavDrawer}>
            {hamburgerMenuIcon}
          </div>
          <Space
            direction="vertical"
            style={{
              cursor: "pointer",
            }}
          >
            <Dropdown
              menu={{ items }}
              trigger={["click"]}
              placement="bottomRight"
              overlayStyle={{
                cursor: "pointer",
              }}
            >
              <button className="profileButton">{userIcon}</button>
            </Dropdown>
          </Space>
        </div>
      </div>
    </div>
  );
};

export default DashboardNavbar;
